import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Dropdown, Navbar, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import AppContext from "context/Context";
import { useTranslation } from "react-i18next";
import styles from "./landing.module.css";
import NavbarDropdown from "./NavbarDropdown";
import { useNavigate } from "react-router-dom";
import { topNavbarBreakpoint } from "config";
import NavbarNavLink from "./NavbarNavLink";
import * as Constants from "../../../common/constants";
import NavbarDropdownPages from "./NavbarDropdownPages";
import jwtDecode from "jwt-decode";
import * as General from "common/general";
import ProfileDropdown from "components/navbar/top/ProfileDropdown";
import BreadCrums from "./BreadCrums";
import { saveMenusToDB, getMenusFromDB, clearMenusFromDB } from "indexedDB";

const NavbarStandard = () => {
	const encryptStorage1 = new EncryptStorage("secret-key-value", {
		prefix: "@mwan",
	});
	var accessToken = encryptStorage1.getItem(Constants.AccessTokenKeyInLocalStorage);
	const [storedLoggedInUserInfo, setStoredLoggedInUserInfo] = useState(() => encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage));
	const [t, i18n] = useTranslation();
	const [isRTL, setIsRTL] = useState(JSON.parse(localStorage.getItem("isRTL")) || false);
	const { setConfig } = useContext(AppContext);
	const navigate = useNavigate();
	const [navbarCollapsed, setNavbarCollapsed] = useState(true);
	const [menuPath, setMenuPath] = useState([]);
	const [publicMenu, setPublicMenu] = useState([]);
	// Add this near the top of your component, before useEffect
	const buildMenuTree = (items) => {
		const normalized = items.map((item) => ({
			...item,
			orderNumber: Number(item.orderNumber),
			isPublic: item.isPublic === "True",
			active: item.active === "True",
			children: [],
		}));

		const itemMap = {};
		normalized.forEach((item) => (itemMap[item.id] = item));

		const tree = [];
		normalized.forEach((item) => {
			if (item.parentId && item.parentId !== "0" && itemMap[item.parentId]) {
				itemMap[item.parentId].children.push(item);
			} else {
				tree.push(item);
			}
		});

		const sortTree = (nodes) => {
			if (!Array.isArray(nodes)) return;
			nodes.sort((a, b) => (a.orderNumber || 0) - (b.orderNumber || 0));
			nodes.forEach((child) => sortTree(child.children));
		};

		sortTree(tree);
		return tree;
	};

	const mergeMenus = (menu1 = [], menu2 = [], key = "attribute") => {
		const mergedMap = new Map();

		const addToMap = (item, isPublic = false) => {
			if (!item[key]) return;
			if (mergedMap.has(item[key])) {
				const existing = mergedMap.get(item[key]);
				existing.children = mergeMenus(existing.children, item.children, key);

				// Prefer public menu label if private menu name is numeric or empty
				const isNumeric = (val) => !isNaN(Number(val));
				if (isPublic || isNumeric(existing.name)) {
					existing.name = item.name || existing.name;
					existing.label = item.label || existing.label;
				}

				mergedMap.set(item[key], existing);
			} else {
				mergedMap.set(item[key], { ...item, children: [...(item.children || [])] });
			}
		};

		menu1.forEach((item) => addToMap(item, false)); // private
		menu2.forEach((item) => addToMap(item, true)); // public

		return Array.from(mergedMap.values()).sort((a, b) => (a.orderNumber || 0) - (b.orderNumber || 0));
	};
	const handleLoginRedirect = () => {
		navigate("/login"); // Redirect to login page
		window.location.reload();
	};
	const handleRedirect = () => {
		navigate("/userTasks"); // Redirect to login page
		window.location.reload();
	};

	const handleMenuItemClick = () => {
		if (window.innerWidth < 992) {
			setNavbarCollapsed(true); // collapse only on mobile
		}
	};

	const changeLanguage = () => {
		setIsRTL((prevIsRTL) => {
			const newIsRTL = !prevIsRTL;
			localStorage.setItem("isRTL", JSON.stringify(newIsRTL));
			setConfig("isRTL", newIsRTL);
			if (newIsRTL) {
				i18n.changeLanguage("ar");
				// keycloakService.changeLanguage("ar");
			} else {
				i18n.changeLanguage("en");
				// keycloakService.changeLanguage("en");
			}
			return newIsRTL;
		});
		window.location.reload();
	};
	const {
		config: { isDark },
	} = useContext(AppContext);

	const GetSystemProperties = () => {
		const GetSystemPropertiesSuccess = (responseObject) => {
			var isSuccess = false;
			if (responseObject.status == Constants.SuccessStatus) {
				if (responseObject.data != null) {
					if (responseObject.data.token != null) {
						if (responseObject.data.token.accessToken != "") {
							let responseData = responseObject.data.dataBaseContent;
							setConfig("systemProperties", responseData);
							encryptStorage1.setItem("systemProperties", responseData);

							isSuccess = true;
							// General.SaveToken(responseObject);
						}
					}
				}
			}

			if (isSuccess == false) {
			} else {
			}
		};

		const GetSystemPropertiesFailure = (GetSystemPropertiesFailure) => {};

		var endPoint = Constants.GetAllEndPoint + "/" + Constants.SystemPropertiesTableName;

		//	General.GetFromEndPoint(endPoint, null, null, GetSystemPropertiesSuccess, GetSystemPropertiesFailure);
	};
	const [routes, setRoutes] = useState([]);
	useEffect(() => {
		const loadMenus = async () => {
			// Load from IndexedDB first
			const cachedMenus = await getMenusFromDB();
			if (cachedMenus && cachedMenus.length > 0) {
				setRoutes(cachedMenus);

				// Optional: fetch in background to refresh cache, but don't overwrite UI
				fetchMenus(true);
				return;
			}

			// No cached menus → fetch from server and update UI
			await fetchMenus(false);
		};

		loadMenus();
	}, []);

	const fetchMenus = async (background = false) => {
		try {
			let publicMenus = [];
			const domain_id = localStorage.getItem("domain") === "localhost" ? (localStorage.getItem("platform") === "inspection" ? 3 : 4) : localStorage.getItem("domain_id");

			// 1️⃣ Convert public menu fetch to a Promise
			publicMenus = await new Promise((resolve) => {
				General.GetFromEndPoint(
					`${Constants.GetPublicMenu}${domain_id}`,
					null,
					null,
					(responseObject) => resolve(responseObject.data),
					() => resolve([])
				);
			});

			saveMenusToDB(publicMenus);
			if (!background) setRoutes(publicMenus);

			// 2️⃣ Stop if user not logged in
			if (!storedLoggedInUserInfo) return;

			// 3️⃣ Private menus fetch also as Promise
			const accessToken = encryptStorage1.getItem(Constants.AccessTokenKeyInLocalStorage);
			const decodedAccessToken = jwtDecode(accessToken);
			const selectedCompany = encryptStorage1.getItem(Constants.SelectedCompany);

			const privateMenus = await new Promise((resolve) => {
				General.GetFromEndPoint(
					`${Constants.GetMenu}${domain_id}?userId=${decodedAccessToken.sub}&companyId=${selectedCompany}`,
					null,
					null,
					(responseObject) => {
						if (responseObject.status === Constants.SuccessStatus) resolve(responseObject.data);
						else resolve([]);
					},
					() => resolve([])
				);
			});

			// 4️⃣ Merge private + public
			const mergedMenus = mergeMenus(privateMenus, publicMenus);
			saveMenusToDB(mergedMenus);

			setRoutes(mergedMenus);
		} catch (error) {
			console.error("❌ Error fetching menus:", error);
			if (!background) setRoutes([]);
		}
	};
	// check if any child of the parent is active
	const isParentActive = (parent) => {
		if (!parent.children || parent.children.length === 0) return false;

		return parent.children.some((child) => {
			if (child.to) {
				const normalize = (p) => p.split("?")[0].replace(/\/+$/, "");
				const current = normalize(location.pathname);
				const target = normalize(child.to);

				if (current === target || current.startsWith(target + "/")) {
					return true;
				}
			}
			// Recursively check deeper children
			return isParentActive(child);
		});
	};
	const findActivePath = (items = [], path = []) => {
		for (const item of items) {
			const newPath = [...path, { name: item.name, to: item.to }];

			if (item.to && typeof item.to === "string") {
				// Normalize both paths (remove query and trailing slash)
				const normalize = (p) => p.split("?")[0].replace(/\/+$/, "");
				const current = normalize(location.pathname);
				const target = normalize(item.to);

				if (current === target || current.startsWith(target + "/")) {
					return newPath;
				}
			}

			if (item.children?.length) {
				const found = findActivePath(item.children, newPath);
				if (found) return found;
			}
		}
		return null;
	};
	const staticRoutes = [
		{ name: t("About the platform"), to: "/aboutus" },
		{ name: t("Contact us"), to: "/contact" },
		{ name: t("User Manual"), to: "/manuals" },
	];
	useEffect(() => {
		const combinedRoutes = [...staticRoutes, ...routes];
		const activePath = findActivePath(combinedRoutes);
		setMenuPath(activePath || []);
		GetSystemProperties();
	}, [location.pathname, routes]);
	return (
		<>
			<Navbar
				variant={isDark ? "light" : "dark"}
				fixed="top"
				expanded={!navbarCollapsed}
				expand={topNavbarBreakpoint}
				className={classNames(
					"navbar-standard navbar-theme",
					"ps-2",
					"pe-2",
					{
						"bg-100": !navbarCollapsed && isDark,
						"bg-100": !navbarCollapsed && !isDark,
					},
					styles.backgroundWhite,
					styles.menuShadow,
					styles.menuPadding
				)}
			>
				<Container>
					<Navbar.Toggle onClick={() => setNavbarCollapsed(!navbarCollapsed)} />
					<Navbar.Brand className={`text-white dark__text-white m-0 p-0`} as={Link} to="/">
						<img src={localStorage.getItem("logo")} className={`${styles.logosize}`} />
					</Navbar.Brand>

					<Navbar.Collapse className={`ms-auto ${isRTL ? styles.rowJustifyRight : styles.rowJustifyLeft}`}>
						<Dropdown className={styles.menuDropDown}>
							<NavbarNavLink
								className={`text-500 ${styles.mainPageMenu}  `}
								//title={t("Main Page")}
								selected={location.pathname === "/"}
								route={{ name: t("Main Page"), to: "/" }} // Link to the main page
								onClick={handleMenuItemClick} // ✅ add this
							></NavbarNavLink>
						</Dropdown>
						{window.location.href.includes("emanifest") ? (
							<Dropdown className={styles.menuDropDown}>
								<NavbarNavLink
									className={`text-500 ${styles.mainPageMenu}`}
									//title={t("Main Page")}
									selected={location.pathname === "/aboutus"}
									route={{ name: t("About the platform"), to: "/aboutus" }} // Link to the main page
									onClick={handleMenuItemClick} // ✅ add this
								></NavbarNavLink>
							</Dropdown>
						) : (
							<></>
						)}

						{routes.map((route) => (
							<NavbarDropdown key={route.name} classes={`${styles.menuDropDown} ${isParentActive(route) ? styles.mainPageMenuSelected : ""}`} title={t(route.name)}>
								<NavbarDropdownPages items={route.children} onItemClick={handleMenuItemClick} />
							</NavbarDropdown>
						))}
						<Dropdown className={styles.menuDropDown}>
							<NavbarNavLink
								className={`text-500 ${styles.mainPageMenu}`}
								//title={t("Main Page")}
								selected={location.pathname === "/contact"}
								route={{ name: t("Contact us"), to: "/contact" }} // Link to the main page
								onClick={handleMenuItemClick} // ✅ add this
							></NavbarNavLink>
						</Dropdown>
					</Navbar.Collapse>
					<Navbar.Collapse className={`scrollbar ${isRTL ? styles.rowJustifyLeft : styles.rowJustifyRight}`}>
						<Nav>
							{window.location.href.includes("emanifest") ? (
								<Link className={`${isRTL ? styles.buttonDownload2 : styles.buttonDownload} ${styles.font300}`} to={"/manuals"}>
									<FontAwesomeIcon icon="fa-file-arrow-down" className={``} transform="shrink-2" />
									{t("User Manual")}
								</Link>
							) : (
								<></>
							)}

							<Link className={`${isRTL ? styles.buttonDownload2 : styles.buttonDownload} ${styles.font300}`} onClick={changeLanguage}>
								<svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
									<path d="M8 15H3.5A2.502 2.502 0 0 1 1 12.5v-9A2.502 2.502 0 0 1 3.5 1h9A2.502 2.502 0 0 1 15 3.5V8h-1V3.5A1.502 1.502 0 0 0 12.5 2h-9A1.502 1.502 0 0 0 2 3.5v9A1.502 1.502 0 0 0 3.5 14H8zm-.038-4.811a9.77 9.77 0 0 1-3.766 1.796l-.242-.97a8.816 8.816 0 0 0 3.282-1.532A9.264 9.264 0 0 1 4.888 5H4V4h3.279l-.544-.544.707-.707L8.692 4H12v1h-.914A9.836 9.836 0 0 1 9.78 8.152a3.853 3.853 0 0 0-1.82 2.037zm.032-1.383A8.167 8.167 0 0 0 10.058 5H5.922a8.18 8.18 0 0 0 2.072 3.806zM23 20.447v-8.894A2.525 2.525 0 0 0 20.484 9h-8.931A2.556 2.556 0 0 0 9 11.553v8.894A2.556 2.556 0 0 0 11.553 23h8.894A2.556 2.556 0 0 0 23 20.447zM20.484 10A1.517 1.517 0 0 1 22 11.516v8.968A1.517 1.517 0 0 1 20.484 22h-8.968A1.517 1.517 0 0 1 10 20.484v-8.968A1.517 1.517 0 0 1 11.516 10zm-2.086 8h-4.796l-1.159 2.23-.886-.46L16 11.215l4.443 8.555-.886.46zm-.52-1L16 13.385 14.122 17z" />
									<path fill="none" d="M0 0h24v24H0z" />
								</svg>
								{isRTL ? "English" : "عربي"}
							</Link>
							{storedLoggedInUserInfo ? (
								// <button className={`${styles.loginButton}`} onClick={handleRedirect}>
								// 	{t("Login")}
								// </button>
								<ProfileDropdown />
							) : (
								<button className={`${styles.loginButton}`} onClick={handleLoginRedirect}>
									{t("Login")}
								</button>
							)}
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
			<BreadCrums crumbs={menuPath} />
		</>
	);
};

export default NavbarStandard;
